import React from 'react';
import cn from 'classnames';
import { IBaseSection, IContent } from 'src/interface';
import { ALIGN_TYPE, LIST_TYPE, Section } from 'src/components';
import { TitleWrap } from 'src/modules/shared/components/TitleWrap';
import ContentList from '../list';

interface IProps extends IBaseSection<IContent> {
    type?: LIST_TYPE;
    hasLayoutPhoto?: boolean;
    displayTimeIn?: number;
    alignList?: ALIGN_TYPE;
    alignItem?: ALIGN_TYPE;
    colMain?: boolean;
    ContentItemComponent?: React.FunctionComponent<any>;
    isMobile?: boolean;
    domRef?: any;
}

export default React.memo(function ContentSection(props: IProps) {
    const {
        items = [],
        title,
        link,
        className = '',
        classTitle = '',
        alignList,
        alignItem,
        type,
        hasLayoutPhoto = true,
        lazyloadImage = true,
        displayTimeIn,
        ContentItemComponent,
        tracking,
        isMobile = true,
        domRef,
    } = props;

    if (!items.length) {
        return null;
    }
    return (
        <Section className={cn(className)} domRef={domRef}>
            <TitleWrap
                className={classTitle}
                title={title}
                link={link}
                renderAs="h2"
            />
            <ContentList
                items={items}
                align={alignList}
                alignItem={alignItem}
                type={type}
                hasLayoutPhoto={hasLayoutPhoto}
                lazyloadImage={lazyloadImage}
                displayTimeIn={displayTimeIn}
                ContentItemComponent={ContentItemComponent}
                tracking={tracking}
                isMobile={isMobile}
            />
        </Section>
    );
});
